import React, { useContext, Fragment } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import AppContext from 'context/Context';

function ResultModal(props) {
  const {
    config: { isDark }
  } = useContext(AppContext);

  /* porps */
  const { resultModalShow, setResultModalShow, statusDetail } = props || {};

  const {
    inspResultTypeNm,
    pltNm,
    sampleCd,
    sampleNm,
    cshipNm,
    coriNm,
    inspReqDt,
    inspCmtDt,
    inspResultIrdntList,
    orgnl_file_path_value
  } = statusDetail || {};

  const onPdfOpen = () => {
    const url = orgnl_file_path_value;
    if (url === undefined || url === null) {
      return;
    }

    window.open(url, '_blank');
  };

  return (
    <Modal
      show={resultModalShow}
      onHide={() => setResultModalShow(false)}
      backdrop="static"
      size="xl"
      centered
    >
      <Modal.Header
        closeButton
        closeVariant={isDark ? 'white' : undefined}
        className="px-card border-bottom-0"
      >
        <Modal.Title>
          검사 항목 선택
          {orgnl_file_path_value && (
            <Button size="sm" className="ms-3" onClick={() => onPdfOpen()}>
              PDF
            </Button>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          bordered
          className="fs--1 text-center"
          style={{ tableLayout: 'fixed' }}
        >
          <thead className="bg-200 text-700 align-middle border-300">
            <tr>
              <th className="text-nowrap">검사결과 Type</th>
              <th className="text-nowrap">공장</th>
              <th className="text-nowrap">원료코드</th>
              <th className="text-nowrap">원료명</th>
              <th className="text-nowrap">모선명</th>
              <th className="text-nowrap">원산지명</th>
              <th className="text-nowrap">검사의뢰일</th>
              <th className="text-nowrap">검사결과 등록일</th>
            </tr>
          </thead>
          <tbody className="align-middle">
            <tr>
              <td>{inspResultTypeNm || '-'}</td>
              <td>{pltNm || '-'}</td>
              <td>{sampleCd || '-'}</td>
              <td>{sampleNm || '-'}</td>
              <td>{cshipNm || '-'}</td>
              <td>{coriNm || '-'}</td>
              <td>{inspReqDt || '-'}</td>
              <td>{inspCmtDt || '-'}</td>
            </tr>
          </tbody>
        </Table>
        <p className="fs--1">● 검사결과</p>
        <div className="scrollbar">
          {inspResultIrdntList?.length > 0 && (
            <Table bordered className="fs--1 text-center mb-0">
              <thead className="bg-200 text-700 align-middle border-300">
                <tr>
                  <th className="text-nowrap py-2 px-3">검사항목</th>
                  {inspResultIrdntList?.map(
                    ({ inspIrdntNm, inspResultIrdntNm }, index) => (
                      <Fragment key={index}>
                        <th className="text-nowrap py-2 px-3">
                          {inspIrdntNm || inspResultIrdntNm}
                        </th>
                      </Fragment>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className="text-nowrap py-2 px-3">검사결과</th>
                  {inspResultIrdntList?.map(({ inspResultVal }, index) => (
                    <Fragment key={index}>
                      <th className="py-2 px-3">{inspResultVal || '-'}</th>
                    </Fragment>
                  ))}
                </tr>
              </tbody>
            </Table>
          )}
          {inspResultIrdntList?.length < 1 && (
            <p className="text-center">검사결과 정보가 존재하지 않습니다.</p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="px-card border-top-0 align-items-center justify-content-center">
        <Button onClick={() => setResultModalShow(false)}>확인</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ResultModal;
